module.exports = __webpack_public_path__ + "img/login-img.27755fa7.png";